/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Frame_DescInputs */

const en_fc_home_features_frame_desc = /** @type {(inputs: Fc_Home_Features_Frame_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An integer timebase keeps 23.976 and 29.97 drop-frame exact, so long timelines never drift out of sync.`)
};

/**
* | output |
* | --- |
* | "An integer timebase keeps 23.976 and 29.97 drop-frame exact, so long timelines never drift out of sync." |
*
* @param {Fc_Home_Features_Frame_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_frame_desc = /** @type {((inputs?: Fc_Home_Features_Frame_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Frame_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_frame_desc(inputs)
});
export { fc_home_features_frame_desc as "fc.home.features.frame.desc" }